import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const state = {
  checkAuth: void 0,
  userData: {
    acl: 'Guests',
    alias: '',
    avatar: require('../../assets/avatar.jpg'),
    data: {},
    email: '',
    isActive: false,
    language: 'tw',
    level: {
      name: '',
      number: 0,
      meter: {
        full: 0,
        now: 0
      }
    },
    nickname: '',
    oauthId: 0,
    organizer: [],
    profile: {
      bio: '',
      category: '',
      gender: '',
      location: ''
    },
    subscription: false,
    timezone: 'Asia/Taipei',
    token: '',
    type: 'bhunter',
    uid: 0
  },
  token: ''
}

const mutations = {
  [types.DATA] (state, data) {
    state.userData = data
  },
  [types.TOKEN] (state, data) {
    state.token = data
  },
  [types.CHECK_AUTH] (state, checked) {
    state.checkAuth = !!checked
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/users/store.js